module.exports = "pegasus_template/assets/blocks/tile-layout-04.png";